module.exports = ['$rootScope', '$state', '$stateRegistry', function ($rootScope, $state, $stateRegistry) {
  
    this.unregister = function (stateName) {
        var watcher = $rootScope.$watch('$viewContentLoaded', function () {
            var state = $state.get(stateName);
            if (state) {
                $stateRegistry.deregister(state.name);
                
            }
            //Unregister Watcher
            watcher();
        });
    }
}];



//////////////////
// WEBPACK FOOTER
// ./src/gateway/core/services/StatesHandler.js
// module id = 193
// module chunks = 2